import { Button, Classes, IButtonProps, Menu, MenuItem, Popover } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import { IWidgetProps } from "decorator-form";
import React from "react";

import { registerWidget } from "common/form/register";
import IOption from "common/models/IOption";
import Label from "core/components/label/Label";
import { number } from "prop-types";

interface IDropdownSelectProps<T = string> extends IWidgetProps<T> {
	buttonProps?: IButtonProps;
	options: Array<IOption<T>>;
	getKeyFromValue?: (value: T) => React.Key;
	equals?: (value1: T, value2: T) => boolean;
}

export default class DropdownSelect<T> extends React.PureComponent<IDropdownSelectProps<T>> {

	public static registerWithOptions(options: IOption[], label?: boolean) {
		return registerWidget(this.withOptions(options), "string");
	}

	public static withOptions(options: IOption[], label?: boolean) {
		return (props: IWidgetProps<any>) => <DropdownSelect {...props} options={options} label={label ? props.label : undefined}/>;
	}

	public render() {
		const { buttonProps, label, onChange, options, value, disabled } = this.props;

		const menu = (
			<div style={{ maxHeight: "100vh", overflow: "hidden", overflowY: "auto" }}>
				<Menu className={Classes.POPOVER_DISMISS_OVERRIDE}>
					{options.map((o) => <MenuItem className={Classes.POPOVER_DISMISS_OVERRIDE} key={this.getKeyFromValue(o.value)} active={o.value === value} onClick={() => onChange(o.value)} text={o.label}/>)}
				</Menu>
			</div>
		);

		let text;

		if (value || typeof value === 'number') {
			const sOption: IOption<T> = options.find((o) => this.valueEquals(o.value, value));
			text = sOption ? sOption.label : '';
		} else if (label) {
			text = label;
		} else {
			text = <Label k="select.default" v="Choose One" />;
		}

		return (
			<div className={Classes.POPOVER_DISMISS_OVERRIDE} >
				<Popover disabled={disabled} content={menu} className={Classes.POPOVER_DISMISS_OVERRIDE} captureDismiss={true}>
					{React.createElement(Button, { text, icon: IconNames.CARET_DOWN, ...buttonProps || {}})}
				</Popover>
			</div>
		);
	}

	private getKeyFromValue = (value: T): React.Key => {
		if (typeof this.props.getKeyFromValue === 'function') {
			return this.props.getKeyFromValue(value);
		}

		if (typeof value === 'string' || typeof value === 'number') {
			return value;
		}

		return value as any; // maybe throw error here?
	}

	private valueEquals = (v1: T, v2: T): boolean => {
		return typeof this.props.equals === 'function' ? this.props.equals(v1, v2) : v1 === v2;
	}
}



// WEBPACK FOOTER //
// ./src/common/form/widgets/common/DropdownSelect.tsx